export default [
  {
    text: 'Advertiser name',
    value: 'name',
    width: '240px',
  },
  {
    text: 'Active platforms',
    value: 'platforms',
    sortable: false,
  },
];
